import { useEffect } from "react";
import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import Services from "../components/Services";
import Features from "../components/Features";
import Gallery from "../components/Gallery";
import VisualizerCTA from "../components/VisualizerCTA";
import Testimonials from "../components/Testimonials";
import FAQ from "../components/FAQ";
import ServiceAreas from "../components/ServiceAreas";
import Contact from "../components/Contact";
import Footer from "../components/Footer";

export default function Home() {
  useEffect(() => {
    window.scrollTo({ top: 0 });
  }, []);

  return (
    <div className="bg-[#FBF8F3]">
      <Navbar />
      <Hero />
      <Services />
      <Features />
      <Gallery />
      <VisualizerCTA />
      <Testimonials />
      <FAQ />
      <ServiceAreas />
      <Contact />
      <Footer />
    </div>
  );
}
